import features from "features";

import { LabelingContextProvider } from "context/LabelingContextProvider";
import { MapContextProvider } from "context/MapContextProvider";

import Layout from "scenes/Layout/_Layout/_Layout";

const Map = (props: any): JSX.Element => {
  const backPath = "/";
  

  return (
    <Layout title="Map" isFullFill backPath={backPath}>
      <MapContextProvider>
        <LabelingContextProvider>
          <features.map.page {...props} />
        </LabelingContextProvider>
      </MapContextProvider>
    </Layout>
  );
};

export default Map;
